export default "__VITE_ASSET__BR$LD4as__"